import { Time } from "@angular/common";

export function toDateOnlyString(d: Date): string {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export function toDateTimeString(d: Date, t: string) : string {
    const date = toDateOnlyString(d);

    const [hours, minutes] = t.split(':').map(Number);

    return `${date} ${hours}:${minutes}:00`;
}

export function timeToShortTime(value: string) : string {
    return value.substring(0, 5);
}

export function toUITime(value: string) : string {
  if (!value) {
    return '';
  }

  const match = value.match(/^\d{4}-\d{2}-\d{2}T(\d{2}):(\d{2})(?::\d{2})?Z?$/);
  if (!match) {
    return '';
  }
  return `${match[1]}:${match[2]}`;
}

export function addMinutesToTime(startTime: string, durationMinutes: number): string {
  const [hours, minutes] = startTime.split(':').map(Number);

  const totalMinutes = hours * 60 + minutes + durationMinutes;

  const endHours = Math.floor(totalMinutes / 60);
  const endMinutes = totalMinutes % 60;

  return `${endHours.toString().padStart(2, '0')}:${endMinutes.toString().padStart(2, '0')}:00`;
}
